<template>
  <div class="ProjectManage">
    <div id="container">
      <app-header :now=3 ></app-header>
      <div class="container_box" style="padding: 0px">
        <router-view></router-view>
        <div id="left_menu">
          <div class="logo">
            <img src="/static/img/logo.png"/>
            <span>智达云服务平台</span>
          </div>
        </div>
        <!--<div id="map"></div>-->
        <div class="projectManage">
          <div class="search">
            <div class="search_box">
              <div class="add_btn_box" style="position: absolute;right: 0px;">
                <button :class='["add_btn","add","icon_btn","clearborder"]' @click="addprojecteditor=!addprojecteditor"><span class="el-icon-circle-plus-outline"></span>新建项目</button>
                <button :class='["add_btn","delete","icon_btn","clearborder"]'><span class="el-icon-delete"></span>批量删除</button>
              </div>
            </div>
          </div>
          <!--        表格-->
          <div class="table_content">
<!--            <el-table-->
<!--              :data="tableData"-->
<!--              style="width: 100%;color: black;background-color: #0b2f54!important;"-->
<!--              row-key="id"-->
<!--              @selection-change="handleSelectionChange"-->
<!--              border-->
<!--              lazy-->
<!--              :load="load"-->
<!--              :tree-props="{children: 'children', hasChildren: 'hasChildren'}">-->
<!--              <el-table-column-->
<!--                type="selection"-->
<!--                width="55" align="center">-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                prop="id"-->
<!--                label="项目编号"-->
<!--                width="80" align="center">-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                prop="create_datetime"-->
<!--                label="创建时间"-->
<!--                width="120" align="center">-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                prop="name"-->
<!--                label="项目名称"-->
<!--                width="120" align="center">-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                prop="address"-->
<!--                label="项目地点" align="center">-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                prop="type"-->
<!--                label="设备类型"-->
<!--                width="120" align="center">-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                prop="investment"-->
<!--                label="项目投资"-->
<!--                width="120" align="center">-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                prop="principal"-->
<!--                label="项目负责人"-->
<!--                width="120" align="center">-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                prop="phone"-->
<!--                label="联系电话"-->
<!--                width="160" align="center">-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                prop="description"-->
<!--                label="项目描述" align="center">-->
<!--              </el-table-column>-->
<!--              <el-table-column-->
<!--                prop="table_btn_box"-->
<!--                label="操作" align="center">-->
<!--                  <el-button  type="warning" size="mini" >+ 添加分组</el-button>-->
<!--                  <el-button  type="primary" size="mini" >编辑</el-button>-->
<!--                  <el-button  type="danger" size="mini" >删除</el-button>-->
<!--              </el-table-column>-->
<!--            </el-table>-->
            <table>
              <thead>
              <tr>
                <th style="padding-left: 30px"><input type="checkbox" name="checkbox" style="width: 16px;height: 16px"></th>
                <th>项目编号</th>
                <th>创建时间</th>
                <th>项目名称</th>
                <th>项目地点</th>
<!--                <th>设备类型</th>-->
                <th>项目投资</th>
                <th>项目负责人</th>
                <th>联系电话</th>
                <th>项目描述</th>
                <th>操作</th>
              </tr>
              </thead>
              <tbody v-for="(item,index) in currentPageData" :key="index">
              <tr>
                <td style="padding-left: 30px"><input type="checkbox" name="checkbox"></td>
                <td>{{index+1}}</td>
                <td>{{item.create_date}}</td>
                <td>{{item.name}}</td>
                <td>{{item.address}}</td>
<!--                <td>{{item.type}}</td>-->
                <td>{{item.invest}}</td>
                <td>{{item.principal}}</td>
                <td>{{item.mobile}}</td>
                <td>{{item.description}}</td>
                <td class="table_btn_box">
                  <!-- <button class="table_btn" @click="LampNewData(item2.lamppost)">最新数据</button> -->
                  <button class="table_btn" style=" margin-right: 10px;" @click="addgroup=!addgroup,GetGroupList(item.id)">编辑群组</button>
                  <button class="table_btn" @click="projecteditor=!projecteditor,GetProject(item.code,item.create_date,item.name,item.invest,item.address,item.principal,item.mobile,item.description,item.id)" style=" margin-right: 10px;">编辑</button>
                  <button class="table_btn" @click="deleteProject(item.id)">删除</button>
                </td>
              </tr>
              </tbody>
            </table>
          </div>
          <div class="table_paging">
            <p>当前记录<span>1</span>到<span>5</span>条，共<span>45</span>条记录
              <button
                v-bind:style="[{background:'url(/static/img/icon/table_start.png) no-repeat center center'}]"></button>
              <button
                v-bind:style="[{background:'url(/static/img/icon/table_prep.png) no-repeat center center'}]"></button>
              第<span>1</span>/<span>5</span>页
              <button
                v-bind:style="[{background:'url(/static/img/icon/table_next.png) no-repeat center center'}]"></button>
              <button
                v-bind:style="[{background:'url(/static/img/icon/table_end.png) no-repeat center center'}]"></button>
            </p>
          </div>
        </div>
      </div>
    </div>
    <!--  项目添加-->
    <transition name="fade">
      <div class="mark" v-if="addprojecteditor">
        <div class="mark_close" @click="addprojecteditor=!addprojecteditor"></div>
        <div :class='["information_box","light_border","weather_box"]'
             :style="[{width:'800px'},{'margin-top':'0px'}]">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model">
            <h1>
              项目添加
            </h1>
            <div class="search_options_box" style="width: 700px;padding-top: 20px;">
              <span style="width: 150px;padding-right: 20px;">项目编号</span>
              <el-input v-model="Pcode" placeholder="请输入项目编号" style="width: 200px;"></el-input>
              <span style="width: 100px;"></span>
              <span style="width: 100px;padding-right: 20px;">创建时间</span>
              <el-input v-model="Pcreate_date" placeholder="请输入创建时间" style="width: 200px;"></el-input>
            </div>
            <div class="search_options_box" style="width: 700px;padding-top: 20px;">
              <span style="width: 150px;padding-right: 20px;">项目名称</span>
              <el-input v-model="Pname" placeholder="请输入项目名称" style="width: 200px;"></el-input>
              <span style="width: 100px;"></span>
              <span style="width: 100px;padding-right: 20px;">项目投资</span>
              <el-input v-model="Pinvest" placeholder="请输入项目投资" style="width: 200px;"></el-input>
            </div>
            <div class="search_options_box" style="width: 400px;padding-top: 20px;">
              <span style="width: 100px;padding-right: 30px;">项目地点</span>
              <el-input v-model="Paddress" placeholder="请输入项目地点" style="width: 170px;"></el-input>
              <span style="width: 50px;"></span>
            </div>
            <div class="search_options_box" style="width: 700px;padding-top: 20px;">
              <span style="width: 150px;padding-right: 20px;">项目负责人</span>
              <el-input v-model="Pprincipal" placeholder="请输入项目负责人" style="width: 200px;"></el-input>
              <span style="width: 100px;"></span>
              <span style="width: 100px;padding-right: 20px;">联系电话</span>
              <el-input v-model="Pmobile" placeholder="请输入联系电话" style="width: 200px;"></el-input>
            </div>
            <div class="search_options_box" style="width: 700px;padding-top: 40px;">
              <span style="width: 130px;padding-right: 20px;">项目描述</span>
              <el-input v-model="Pdescription" placeholder="请输入项目描述"   type="textarea" :rows="5"></el-input>
            </div>
            <div class="sbt_box" style="padding-top: 30px;">
              <button :class='["add_btn","delete","icon_btn","clearborder"]'  @click="addprojecteditor=!addprojecteditor">取消</button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="addProject(),addprojecteditor=!addprojecteditor">提交</button>
            </div>
          </div>
        </div>
      </div>
    </transition>


    <!--  项目编辑-->
    <transition name="fade">
      <div class="mark" v-if="projecteditor">
        <div class="mark_close" @click="projecteditor=!projecteditor"></div>
        <div :class='["information_box","light_border","weather_box"]'
             :style="[{width:'800px'},{'margin-top':'0px'}]">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model">
            <h1>
              项目编辑
            </h1>
            <div class="search_options_box" style="width: 700px;padding-top: 20px;">
              <span style="width: 150px;padding-right: 20px;">项目编号</span>
              <el-input v-model="Pcode" placeholder="请输入项目编号" style="width: 200px;"></el-input>
              <span style="width: 100px;"></span>
              <span style="width: 100px;padding-right: 20px;">创建时间</span>
              <el-input v-model="Pcreate_date" placeholder="请输入创建时间" style="width: 200px;"></el-input>
            </div>
            <div class="search_options_box" style="width: 700px;padding-top: 20px;">
              <span style="width: 150px;padding-right: 20px;">项目名称</span>
              <el-input v-model="Pname" placeholder="请输入项目名称" style="width: 200px;"></el-input>
              <span style="width: 100px;"></span>
              <span style="width: 100px;padding-right: 20px;">项目投资</span>
              <el-input v-model="Pinvest" placeholder="请输入项目投资" style="width: 200px;"></el-input>
            </div>
            <div class="search_options_box" style="width: 400px;padding-top: 20px;">
              <span style="width: 100px;padding-right: 30px;">项目地点</span>
              <el-input v-model="Paddress" placeholder="请输入项目地点" style="width: 170px;"></el-input>
              <span style="width: 50px;"></span>
            </div>
            <div class="search_options_box" style="width: 700px;padding-top: 20px;">
              <span style="width: 150px;padding-right: 20px;">项目负责人</span>
              <el-input v-model="Pprincipal" placeholder="请输入项目负责人" style="width: 200px;"></el-input>
              <span style="width: 100px;"></span>
              <span style="width: 100px;padding-right: 20px;">联系电话</span>
              <el-input v-model="Pmobile" placeholder="请输入联系电话" style="width: 200px;"></el-input>
            </div>
            <div class="search_options_box" style="width: 700px;padding-top: 40px;">
              <span style="width: 130px;padding-right: 20px;">项目描述</span>
              <el-input v-model="Pdescription" placeholder="请输入项目描述"   type="textarea" :rows="5"></el-input>
            </div>
            <div class="sbt_box" style="padding-top: 30px;">
              <button :class='["add_btn","delete","icon_btn","clearborder"]'  @click="projecteditor=!projecteditor,deletegetproject()">取消</button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="updateProject(),projecteditor=!projecteditor">提交</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!--  编辑群组-->
    <transition name="fade">
      <div class="mark" v-if="addgroup">
        <div class="mark_close" @click="addgroup=!addgroup"></div>
        <div :class='["information_box","light_border","weather_box"]'
             :style="[{width:'800px'},{'margin-top':'0px'}]">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model">
            <h1>
              编辑群组
            </h1>
            <el-tag
              :key="tag"
              v-for="tag in dynamicTags"
              closable
              :disable-transitions="false"
              @close="handleClose1(tag)">
              <button :class='["look_btn","icon_btn","clearborder"]' style="background-color: #ecf5ff;color: #409eff;" @click="addteam=!addteam,GetTeamList(tag.id)">{{tag.name}}</button>
            </el-tag>
            <el-input
              class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              size="medium"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </el-input>
            <el-button v-else class="button-new-tag" size="medium" @click="showInput" style="position: relative;top: 10px;">+ 新增群组</el-button>
            <div class="sbt_box" style="padding-top: 30px;">
              <button :class='["add_btn","delete","icon_btn","clearborder"]'  @click="addgroup=!addgroup">关闭</button>
<!--              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="brightness_sbt()">提交</button>-->
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!--  编辑小组-->
    <transition name="fade">
      <div class="mark" v-if="addteam">
        <div class="mark_close" @click="addteam=!addteam"></div>
        <div :class='["information_box","light_border","weather_box"]'
             :style="[{width:'800px'},{'margin-top':'0px'}]">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model">
            <h1>
              编辑小组
            </h1>
            <el-tag
              :key="tag"
              v-for="tag in teamTags"
              closable
              :disable-transitions="false"
              @close="handleClose2(tag)">
              {{tag.IMEI}}
            </el-tag>
            <el-input
              class="input-new-tag"
              v-if="inputVisible"
              v-model="inputValue"
              ref="saveTagInput"
              size="medium"
              @keyup.enter.native="handleInputConfirm"
              @blur="handleInputConfirm"
            >
            </el-input>
            <el-button type="primary" size="medium" @click="addcontroller=!addcontroller,addteam=!addteam,addgroup=!addgroup" style="position: relative;top: 10px;">+ 新增小组</el-button>
            <div class="sbt_box" style="padding-top: 30px;">
              <button :class='["add_btn","delete","icon_btn","clearborder"]'  @click="addteam=!addteam">关闭</button>
              <!--              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="brightness_sbt()">提交</button>-->
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!--  添加集控器-->
    <transition name="fade">
      <div class="mark" v-if="addcontroller">
        <div class="mark_close" @click="addcontroller=!addcontroller"></div>
        <div :class='["information_box","light_border","weather_box"]'
             :style="[{width:'800px'},{'margin-top':'0px'}]">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model">
            <h1>
              添加小组
            </h1>
            <div style="color:white;padding-left: 238px;padding-top: 10px;">
              IMEI：<el-input v-model="imei" placeholder="请输入IMEI" style="width: 200px;"></el-input>
            </div>
            <div style="color:white;padding-left: 240px;padding-top: 10px;">
              经度：<el-input v-model="lng" placeholder="请输入经度" style="width: 200px;"></el-input>
            </div>
            <div style="color:white;padding-left: 240px;padding-top: 10px;">
              纬度：<el-input v-model="lat" placeholder="请输入纬度" style="width: 200px;"></el-input>
            </div>
            <div style="color:white;padding-left: 208px;padding-top: 10px;">
              地理位置：<el-input v-model="site" placeholder="请输入地理位置" style="width: 200px;"></el-input>
            </div>
            <div class="sbt_box" style="padding-top: 30px;">
              <button :class='["add_btn","delete","icon_btn","clearborder"]'  @click="addcontroller=!addcontroller">关闭</button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="addController(),addcontroller=!addcontroller">提交</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
  // import HelloWorld from './components/HelloWorld'
  import Header from "./Header";

  export default {
    name: 'projectManage',
    components: {
      "app-header": Header,
    },
    data() {
      return {
        addprojecteditor:false,
        groupName:'',
        groupId:[],
        dynamicTags: [],
        teamTags: [],
        inputVisible: false,
        inputValue: '',
        textarea: '河北省科技厅高科技成果展',
        qwerqwre: 0,
        projecteditor: false,//项目
        addgroup:false,//添加群组
        addteam:false,//添加小组
        addcontroller:false,
        currentPageData: [],
        project_id:"",
        //project_ids:[],
        imei:'',
        lng:'',
        lat:'',
        site:'',
        Pcode:'',
        Pname:'',
        Pprincipal:'',
        Pmobile:'',
        Pinvest:'',
        Paddress:'',
        Pcreate_date:'',
        Pdescription:'',
        Pid:'',

      }
    },
    created: function () {
      //this.GetGroupList();
      $(function () {
        let aa = $(".aa"),
          bb = $(".bb");
        aa.css('display', 'block');
        aa.find('ul').hide();
        aa.click(function () {
          $(this).find('ul').slideDown(500);
          $(this).siblings().children("ul").slideUp(500);
        });
        bb.click(function () {
          bb.removeClass('now');
          $(this).addClass('now');
        })
      }),
      //获取项目列表
      fetch("/api/v1/project/list", {
        method: 'post',
        body: JSON.stringify({
          "project_id": this.project_id,
        })
      })
        .then(result => {
          return result.json();//解析流
        })
        .then(data => {
          this.currentPageData = data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    methods: {
      addClassFun: function (index) {
        this.qwerqwre = index;
      },
      handleClose1(tag) {
        this.deleteGroup(tag.id);
        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        this.teamTags.splice(this.teamTags.indexOf(tag), 1);
      },

      handleClose2(tag) {
        this.deleteController(tag.id);
      },

      showInput() {
        this.inputVisible = true;
        this.$nextTick(_ => {
          this.$refs.saveTagInput.$refs.input.focus();
        });
      },

      handleInputConfirm() {
        let inputValue = this.inputValue;
        if (inputValue) {
          this.dynamicTags.push(inputValue);
          this.teamTags.push(inputValue);
          this.groupName=this.inputValue;
          //alert(this.groupName);
          this.addGroup();
        }
        this.inputVisible = false;
        this.inputValue = '';
      },

      //获取项目编辑列表
      GetProject:function(code,create_date,name,invest,address,principal,mobile,description,id){
          this.Pcode=code,
          this.Pname=name,
          this.Pprincipal=principal,
          this.Pmobile=mobile,
          this.Pinvest=invest,
          this.Paddress=address,
          this.Pcreate_date=create_date,
          this.Pdescription=description,
          this.Pid = id
      },

      //项目编辑还原
      deletegetproject:function(){
        this.Pcode='',
          this.Pname='',
          this.Pprincipal='',
          this.Pmobile='',
          this.Pinvest='',
          this.Paddress='',
          this.Pcreate_date='',
          this.Pdescription='',
          this.Pid = ''
      },


      //获取集控器列表
      GetTeamList:function (group_id) {
        fetch("/api/v1/controller/list", {
          method: 'post',
          body: JSON.stringify({
            "groups_id" : group_id,
            "page_start" : "0",
            "page_size" : "10",
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          .then(data => {
            this.teamTags=data.data;
            this.groupId = group_id;
            console.log(this.teamTags);
          })
          .catch((error) => {
            console.log(error);
          });
      },

      //获取群组列表
      GetGroupList:function (project_id) {
        fetch("/api/v1/groups/list", {
          method: 'post',
          body: JSON.stringify({
            "page_start" : "0",
            "page_size" : "10",
            "project_id" : project_id,
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          .then(data => {
            this.dynamicTags=data.data;
            this.project_id = project_id;
            console.log(this.dynamicTags);
          })
          .catch((error) => {
            console.log(error);
          });
      },

      //删除群组
      deleteGroup:function (group_id) {
        fetch("/api/v1/groups/delete", {
          method: 'post',
          body: JSON.stringify({
            "groups_id" : [group_id],
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          .then(data => {
            if (data.code == "200") {
              this.message = "群组删除成功";
              this.msg_show = !this.msg_show;
              alert(this.message);
            } else {
              this.message = "操作异常，请重试";
              this.msg_show = !this.msg_show;
              alert(this.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },


      //删除集控器
      deleteController:function (controller_id) {
        fetch("/api/v1/controller/delete", {
          method: 'post',
          body: JSON.stringify({
            "controller_id" : [controller_id],
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          .then(data => {
            if (data.code == "200") {
              this.message = "小组删除成功";
              this.msg_show = !this.msg_show;
              alert(this.message);
            } else {
              this.message = "操作异常，请重试";
              this.msg_show = !this.msg_show;
              alert(this.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },


      //添加群组
      addGroup:function () {
        fetch("/api/v1/groups/add", {
          method: 'post',
          body: JSON.stringify({
            "name" : this.groupName,
            "project_id" : this.project_id,
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          .then(data => {
            if (data.code == "200") {
              this.message = "群组添加成功";
              this.msg_show = !this.msg_show;
              alert(this.message);
            } else {
              this.message = "操作异常，请重试";
              this.msg_show = !this.msg_show;
              alert(this.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },

      //添加项目
      addProject:function () {
        fetch("/api/v1/project/add", {
          method: 'post',
          body: JSON.stringify({
            "code":this.Pcode,
            "name":this.Pname,
            "principal":this.Pprincipal,
            "mobile":this.Pmobile,
            "invest":this.Pinvest,
            "address":this.Paddress,
            "create_date":this.Pcreate_date,
            "description":this.Pdescription,
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          .then(data => {
            if (data.code == "200") {
              this.message = "项目添加成功";
              this.msg_show = !this.msg_show;
              alert(this.message);
            } else {
              this.message = "操作异常，请重试";
              this.msg_show = !this.msg_show;
              alert(this.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },


      //修改项目
      updateProject:function () {
        fetch("/api/v1/project/update", {
          method: 'post',
          body: JSON.stringify({
            "project_id":this.Pid,
            "code":this.Pcode,
            "name":this.Pname,
            "principal":this.Pprincipal,
            "mobile":this.Pmobile,
            "invest":this.Pinvest,
            "address":this.Paddress,
            "create_date":this.Pcreate_date,
            "description":this.Pdescription,
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          .then(data => {
            if (data.code == "200") {
              this.message = "项目修改成功";
              this.msg_show = !this.msg_show;
              alert(this.message);
            } else {
              this.message = "操作异常，请重试";
              this.msg_show = !this.msg_show;
              alert(this.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },


      //删除项目
      deleteProject:function (project_id) {
        fetch("/api/v1/project/delete", {
          method: 'post',
          body: JSON.stringify({
            "project_id" : [project_id],
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          .then(data => {
            if (data.code == "200") {
              this.message = "项目删除成功";
              this.msg_show = !this.msg_show;
              alert(this.message);
            } else {
              this.message = "操作异常，请重试";
              this.msg_show = !this.msg_show;
              alert(this.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },


      //添加集控器
      addController:function () {
        fetch("/api/v1/controller/add", {
          method: 'post',
          body: JSON.stringify({
            "imei" : this.imei,
            "manufacturer" : "智达光电",
            "lng" : this.lng,
            "lat" : this.lat,
            "site" : this.site,
            "groups_id" : this.groupId,
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          .then(data => {
            if (data.code == "200") {
              this.message = "集控器添加成功";
              this.msg_show = !this.msg_show;
              alert(this.message);
            } else {
              this.message = "操作异常，请重试";
              this.msg_show = !this.msg_show;
              alert(this.message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      },


    }
  }
</script>

<style scoped>
  #left_menu {
    width: 270px;
    height: 78px;
    position: absolute;
    left: 0;
    top: 0;
    background: #1d4e80
  }

  #left_menu .logo {
    width: 100%;
    height: 78px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  #left_menu .logo img {
    margin-right: 10px;
  }

  #left_menu .logo span {
    font-size: 22px;
    color: #ffffff;
    font-weight: bold;
  }
  .container_box {
    background: url("/static/img/bg.jpg") no-repeat center center;
    background-size: 100% 100%;
    width: 100%;
    height: calc(100% - 78px);
    overflow-y: auto;
    box-sizing: border-box;
  }
  ::-webkit-scrollbar-track-piece {
    background-color: transparent; /*滚动条的背景颜色*/
    -webkit-border-radius: 0; /*滚动条的圆角宽度*/
  }

  ::-webkit-scrollbar {
    width: 8px; /*滚动条的宽度*/
    height: 8px; /*滚动条的高度*/
  }

  ::-webkit-scrollbar-thumb { /*垂直滚动条的样式*/
    height: 50px;
    background-color: #95bee5;
    -webkit-border-radius: 4px;
    outline-offset: -2px;
  }

  ::-webkit-scrollbar-thumb:hover { /*滚动条的hover样式*/
    height: 50px;
    background-color: #00f0ff;
    -webkit-border-radius: 4px;
  }
  #map{
    width: 100%;
    height: 100%;
  }

  .projectManage{
    width: 100%;
    height: 100%;
    padding: 0 20px;
    box-sizing: border-box;
  }

  .search {
    width: 100%;
    height: 100px;
    padding: 20px 0px 0px;
  }

  .search_box {
    width: 100%;
    height: 100%;
    margin-right: 10px;
    background: #16518d;
    border-radius: 6px;
    float: left;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    position: relative;
  }

  .search_options_box {
    width: 16%;
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .search_options_box > span {
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }

  .search_options_box > select {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #ffffff;
    color: #ffffff;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_box option {
    color: #000000;
  }

  .search_options_box > img {
    position: absolute;
    top: 48px;
    right: 20px;
    cursor: pointer;
  }

  .search_btn_box {
    width: 80px;
    padding: 10px;
  }

  .clearborder {
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .search_btn {
    width: 100%;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
  }

  .add_btn {
    width: 110px;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
    float: left;
    margin-right: 20px;
  }

  .look_btn {
    width: 90px;
    height: 30px;
    /*border-radius: 6px;*/
    /*line-height: 32px;*/
    float: left;
    /*margin-right: 20px;*/
  }

  .icon_btn span {
    margin-right: 8px;
  }

  .green {
    background: #21b868;
    color: #FFFFFF;
  }

  .green:active {
    background: #15a95a;
  }

  .add_btn_box {
    /*width: 370px;*/
    padding: 10px;
  }

  .add {
    background: #7aafeb;
    color: #FFFFFF;
    box-shadow: 0px 3px 0px #3574ba;
  }

  .add:active {
    background: #6ca3e2;
  }

  .delete {
    background: #f2ae4d;
    color: #FFFFFF;
    box-shadow: 0px 3px 0px #dc8509;
  }

  .delete:active {
    background: #e7a342;
  }
  .table_content{
    width: 100%;
    padding: 20px 0px;
  }

  .table_content > table {
    width: 100%;
    height: 100%;
    border: 1px solid #094b8e;
    background-color: #16518d;
  }

  .table_content > table tr th{
    background-color: #0e345b;
  }
  .table_content > table tr td{
    /*background-color: #16518d;*/
  }

  .table_content > table tr td input{
    width: 16px;
    height: 16px;

  }

  .table_content > table tr:nth-child(2n){
    background-color: #11406f;
  }

  .table_content > table tr {
    /*border-bottom: 1px solid #225892;*/
    height: 62px
  }

  .table_content > table tr td, .table_content > table tr th {
    text-align: center;
    color: #FFFFFF;
  }

  .table_paging {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid #105ba8;
    border-radius: 6px;
  }

  .table_paging > p {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: right;
    margin-bottom: 0;
    color: #c1c2c6;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }

  .table_paging > p > button {
    margin: 0 8px;
    width: 10px;
    height: 16px;
    border: none;
    outline: none;
  }

  .table_btn{
    color: #95bee5;
    background: transparent;
    border: 1px solid #95bee5;
    outline: transparent;
    padding: 5px 20px;
    border-radius: 6px;
  }
  .thCls {
    color: #1c7430!important;
    background-color: #0a60d6!important;
    background:#0a60d6!important;
    font-size: 30px;
  }

  .el-table__header th, .el-table__header tr {
    background-color: red!important;
    color: black;
  }

  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
</style>



// WEBPACK FOOTER //
// src/components/ProjectManage.vue